export default function isQABot() {
  return navigator.userAgent === 'qa-automation-bot';
}
